import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { NotificationDto } from '../types/types';
import { WEBSOCKET_URL } from './api';

interface WebSocketConfigParams {
    onMessageReceived: (notification: NotificationDto) => void;
    onFetchNotifications: () => void;
    onFetchChatNotifications: () => void;
}

export const initializeWebSocket = ({
    onMessageReceived,
    onFetchNotifications,
    onFetchChatNotifications
}: WebSocketConfigParams): { client: Client; cleanup: () => void } => {
    const userJson = localStorage.getItem('loginResponse');
    const user = userJson ? JSON.parse(userJson) : null;
    const userId = user?.id || null;
    const token = user?.token || null;

    if (!userId) {
        console.error('User ID not found in local storage');
        return { client: new Client(), cleanup: () => { } };
    }

    const client = new Client({
        webSocketFactory: () => new SockJS(WEBSOCKET_URL),
        connectHeaders: {
            Authorization: `Bearer ${token || ''}`,
        },
        debug: (str) => {
            console.log('STOMP Debug:', str);
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
    });

    client.onConnect = (frame) => {
        console.log('Connected to WebSocket:', frame);
        client.subscribe(`/user/${userId}/reply`, (message) => {
            try {
                const notification: NotificationDto = JSON.parse(message.body);
                onMessageReceived(notification);
                onFetchNotifications();
                onFetchChatNotifications();
            } catch (error) {
                console.error('Error parsing notification:', error);
            }
        });
    };

    client.onStompError = (frame) => {
        console.error('STOMP Error:', frame.headers['message']);
        console.error('Additional details:', frame.body);
    };

    client.onWebSocketError = (error) => {
        console.error('WebSocket Error:', error);
    };

    client.onDisconnect = () => {
        console.log('Disconnected from WebSocket');
    };

    client.activate();

    const cleanup = () => {
        if (client) {
            client.deactivate();
        }
    };

    return { client, cleanup };
};